import { useMutation } from "react-query";
import { addMasterLegalEntity } from "../../../../../actions/Utilities/MasterLegalEntity";
import { toast } from "components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateMasterLegalEntity,
  masterLegalEntityFetching,
} from "../atoms/atoms";
import { IMasterLegalEntity } from "../type/MasterLegalEntityTypeInterface";

const useAddMasterLegalEntity = () => {
  const setActionAddState = useSetRecoilState(addStateMasterLegalEntity);
  const [isReFetching, setIsReFetching] = useRecoilState(
    masterLegalEntityFetching
  );
  const { mutate } = useMutation(
    (NewData: IMasterLegalEntity) => addMasterLegalEntity(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Master Legal Entity Added Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Master Legal Entity Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Master Legal Entity failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Business Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Adding Master Legal Entity failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire(
              "Adding Master Legal Entity failed",
              res.Message,
              "error"
            );
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire(
          "Add Master Legal Entity failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
};
export default useAddMasterLegalEntity;
